// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1f_es","obliqueLineWrap":"membershipbadge_obliqueLineWrap__20xni","obliqueLine":"membershipbadge_obliqueLine__16xaP"};